import React from 'react';
import { FsDirection } from 'globals/types';
import useTheme from '@material-ui/core/styles/useTheme';
import { purple } from 'globals/colors';

interface FsPaginationVectorArrowIconProps {
  color?: string;
  direction?: FsDirection;
  disabled?: boolean;
}

const getRotationDegree = (direction: FsDirection): string => {
  switch (direction) {
    case FsDirection.RIGHT:
      return '0deg';
    case FsDirection.DOWN:
      return '90deg';
    case FsDirection.LEFT:
      return '180deg';
    case FsDirection.UP:
      return '270deg';
    default:
      return '0deg';
  }
};

const FsPaginationVectorArrowIcon: React.FC<FsPaginationVectorArrowIconProps> = ({
  color = purple.BRAND,
  direction = FsDirection.RIGHT,
  disabled,
}) => {
  const { palette } = useTheme();
  const activeColor = disabled ? palette.grey[200] : color;
  const rotationDegree = getRotationDegree(direction);
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: `rotate(${rotationDegree})`,
      }}
    >
      <path
        d="M1.4375 1L7.875 7.4375L1.4375 13.875"
        stroke={activeColor}
        strokeWidth="1.4"
      />
    </svg>
  );
};

export default FsPaginationVectorArrowIcon;
